export default defineNuxtRouteMiddleware(({ path: toPath, query: toQuery }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { $store } = useNuxtApp() as any;

  const currentPath = toPath;
  const pathsLogoutAllowed = [REGISTER_BASE_URL];
  const pathsLoginAllowed = [
    PROFILE_PAGE,
    FAVOURITES_URL,
    MY_EVENTS_BASE_URL,
    MY_STARTUPS_BASE_URL
  ];

  if ($store.getters['auth/getByField']('loggedIn')) {
    // if (pathsLogoutAllowed.includes(currentPath) && toQuery.type !== 'event') {
    //   return navigateTo(HOME_PAGE, { replace: true, redirectCode: 301 })
    // }
  } else if (pathsLoginAllowed.includes(currentPath)) {
    return navigateTo(`/?redirect=${encodeURIComponent(currentPath)}`);
  } else if (
    toQuery.token &&
    toQuery.type === 'cxtierra' &&
    !pathsLogoutAllowed.includes(currentPath)
  ) {
    return navigateTo({ path: toPath, query: undefined });
  }
});
